var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

export default ClockType;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/pickers/esm/constants/ClockType.js
// module id = 251
// module chunks = 0